import {
  Avatar,
  Dialog,
  IconButton,
  InputAdornment,
  Skeleton,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { font } from "../../../styles/font";
import { TextFieldMA } from "../../../styles/styledComponents";
import { theme } from "../../../styles/theme";
import { stringAvatar } from "../../../utility/string";
import { ButtonCustom } from "../../button";
import SearchIcon from "@mui/icons-material/Search";
import { NoDataFound } from "../../noDataFound";
import { revokeUser } from "../../../api/controllers/registeredUserController";
import { HttpStatusCode } from "axios";
import CancelIcon from "@mui/icons-material/Cancel";
import { GlobalSnackBar } from "../../snackBar";

export const RevokedUsers = ({
  profileQuery,
  revokedEmployeesData,
  loaderState,
  setReloadEmployees,
}) => {
  // employeesData.length = 0;
  const [search, setSearch] = useState("");
  const [email, setEmail] = useState("");
  const [openRevokeDialog, setOpenRevokeDialog] = useState(false);
  const [registerSnack, setRegisterSnack] = useState(false);
  const [error, setError] = useState("");
  let timeout;
  let searchResult;

  const handleEmployees = async () => {
    try {
      let response = await revokeUser({
        email,
      });
      console.log(response, "responseLogin");
      if (response.status === HttpStatusCode.Ok) {
        setError(response.data.message);
        setRegisterSnack(true);
        setReloadEmployees(true);
        setTimeout(() => {
          setReloadEmployees(false);
        }, 400);
      }
      if (response.status === HttpStatusCode.BadRequest) {
        setError(response.data.message);
        setRegisterSnack(true);
      }
      if (response.status === HttpStatusCode.InternalServerError) {
        setError(response.data.message);
        setRegisterSnack(true);
      }

      if (response.status === HttpStatusCode.Forbidden) {
        setError(response.data.message);
        setRegisterSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelection = (users) => {
    setOpenRevokeDialog(true);
    setEmail(users.email);
  };
  const handleSearch = (e) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      console.log(e.target.value);
      setSearch(e.target?.value?.toLowerCase());
    }, 1000);
  };
  console.log(search, "search");
  return (
    <>
      <Box width="100%" display="flex" flexDirection="column" gap="23px">
        <Box display="flex" width="25%" alignItems="center">
          <TextFieldMA
            onChange={handleSearch}
            sx={{ minWidth: "200px" }}
            size="small"
            label="Search"
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {<SearchIcon sx={{ color: theme.col_2 }} />}
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box
          width="100%"
          display="flex"
          flexWrap={"wrap"}
          gap="18px"
          //   justifyContent="flex-start"
        >
          {loaderState ? (
            <>
              {Array.from(Array(3).keys())?.map((skeleton) => {
                return (
                  <Box
                    display="flex"
                    alignItems="center"
                    border={"1px solid rgb(229, 234, 242)"}
                    width={profileQuery ? "100%" : "28.4%"}
                    minWidth="227px"
                    height="100px"
                    borderRadius="8px"
                    backgroundColor={theme.col_3_alpha}
                    flexDirection="row"
                    gap="13px"
                    overflow="hidden"
                    padding="0px 15px 0px 15px"
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      width={"70px"}
                      height="70px"
                      borderRadius="100px"
                      overflow="hidden"
                    >
                      <Skeleton
                        variant="rectangular"
                        sx={{ backgroundColor: theme.col_4 }}
                        animation="wave"
                        width={"100%"}
                        height={"100%"}
                      />
                    </Box>
                    <Box
                      display="flex"
                      alignItems="flex-start"
                      flexDirection="column"
                      flex="1"
                    >
                      <Skeleton
                        variant="text"
                        sx={{ backgroundColor: theme.col_4 }}
                        animation="wave"
                        width={"100%"}
                        height={"100%"}
                      />
                      <Skeleton
                        variant="text"
                        sx={{ backgroundColor: theme.col_4 }}
                        animation="wave"
                        width={"100%"}
                        height={"100%"}
                      />
                    </Box>
                  </Box>
                );
              })}
            </>
          ) : (
            <>
              {revokedEmployeesData
                ?.filter((filter, i) => {
                  if (search === "") {
                    return filter;
                  }
                  if (filter?.name?.toLowerCase().includes(search)) {
                    return filter;
                  }

                  if (filter?.designation?.toLowerCase().includes(search)) {
                    return filter;
                  }

                  return false;
                })
                .map((users, i, result) => {
                  console.log(result, "resultArray");
                  searchResult = result;

                  return (
                    <Box
                      display="flex"
                      alignItems="center"
                      // flex="1 1 330px"
                      border={"1px solid rgb(229, 234, 242)"}
                      //   width={"29.4%"}
                      width={profileQuery ? "100%" : "29.4%"}
                      minWidth="227px"
                      height="117px"
                      borderRadius="8px"
                      backgroundColor={theme.col_4}
                      flexDirection="row"
                      gap="13px"
                      padding="0px 14px 0px 14px"
                    >
                      <Avatar {...stringAvatar(users.name)} />

                      <Box
                        display="flex"
                        alignItems="flex-start"
                        backgroundColor={theme.col_4}
                        flexDirection="column"
                        flex="1"
                        overflow='hidden'
                      >
                        <Typography
                          noWrap
                          onClick={() => setRegisterSnack(true)}
                          fontFamily={font.family.fm_2}
                          fontSize={font.size.fs_3}
                          color={theme.col_6}
                          fontWeight="bold"
                        >
                          {users.name}
                        </Typography>
                        <Typography
                          noWrap
                          fontFamily={font.family.fm_2}
                          fontSize={font.size.fs_4}
                          color={theme.col_8}
                          fontWeight="bold"
                        >
                          {users.designation}
                        </Typography>
                        <Typography
                          noWrap
                          fontFamily={font.family.fm_2}
                          fontSize={font.size.fs_4}
                          color={theme.col_8}
                          fontWeight="bold"
                        >
                          {users.email}
                        </Typography>
                      </Box>
                      <ButtonCustom
                        onClick={() => handleSelection(users)}
                        width={"100px"}
                        disabled={false}
                        borderRadius="42px"
                        size="small"
                        background={theme.col_2_alpha}
                        backgroundRipple={theme.col_3_alpha}
                        focusColor={theme.col_2}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        typography={
                          <Typography
                            fontFamily={font.family.fm_2}
                            textTransform={"capitalize"}
                            fontSize={font.size.fs_4}
                            fontWeight="bold"
                            color={theme.col_2}
                          >
                            unban
                          </Typography>
                        }
                      />
                    </Box>
                  );
                })}
            </>
          )}
          {(revokedEmployeesData.length === 0 && !loaderState) ||
          (!searchResult && !loaderState) ? (
            <Box
              width="100%"
              display="flex"
              flex={1}
              height="140px"
              justifyContent="center"
              alignItems="center"
            >
              <NoDataFound message={"Employee data not found"} />
            </Box>
          ) : (
            <></>
          )}
        </Box>
      </Box>
      <GlobalSnackBar
        open={registerSnack}
        title={error}
        close={setRegisterSnack}
      />

      <Dialog
        open={openRevokeDialog}
        fullWidth
        maxWidth={"100%"}
        maxheight={"100%"}
        PaperProps={{
          style: {
            maxHeight: "100%",
            width: "363px",
          },
        }}
        onClose={() => {
          setOpenRevokeDialog(false);
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="13px"
          width="100%"
          padding="18px 0px"
          backgroundColor={theme.col_4}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap="13px"
            width="90%"
            backgroundColor={theme.col_4}
          >
            <Box
              display="flex"
              justifyContent="center"
              width="100%"
              alignItems="center"
            >
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_5}
                fontWeight="bold"
                color={theme.col_3}
                flex="1"
              >
                {"Revoke user"}
              </Typography>
              <IconButton onClick={() => setOpenRevokeDialog(false)}>
                <CancelIcon sx={{ fontSize: "32px", color: theme.col_2 }} />
              </IconButton>
            </Box>
            <Typography
              fontFamily={font.family.fm_2}
              textTransform={"capitalize"}
              fontSize={font.size.fs_3}
              fontWeight="bold"
              // textAlign="center"
              color={theme.col_2}
            >
              Are you sure you want revoke current user
            </Typography>
            <Box
              display="flex"
              gap="14px"
              alignItems="center"
              flexDirection="column"
              width="100%"
              backgroundColor={theme.col_4}
            >
              <ButtonCustom
                onClick={handleEmployees}
                fullWidth={false}
                disabled={false}
                width="100px"
                height="35px"
                // borderRadius="42px"
                // size="large"
                background={theme.col_2}
                backgroundRipple={theme.col_3}
                focusColor={theme.col_1}
                display="flex"
                alignItems="center"
                justifyContent="center"
                typography={
                  <Typography
                    fontFamily={font.family.fm_2}
                    textTransform={"capitalize"}
                    fontSize={font.size.fs_3}
                    // fontWeight="bold"
                    color={theme.col_4}
                  >
                    confirm
                  </Typography>
                }
              />
            </Box>
          </Box>
          {/* <Subscriptions upgrade={true}/> */}
        </Box>
      </Dialog>
    </>
  );
};
